import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { resolvePunditImageList } from '../utils/imageUrl';

const PoojaDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    setLoading(true);
    setActiveImg(0);
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/poojas/${id}`)
      .then((res) => res.json())
      .then((details) => setData(details?.id ? details : null))
      .catch((err) => {
        console.error('Unable to load pooja details', err);
        setData(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="p-20">Loading details...</div>;
  if (!data) return <div className="p-20">Pooja details not found.</div>;

  const gallery = resolvePunditImageList(data.gallery?.length ? data.gallery : data.images || []);

  return (
    <motion.div className="details-view-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <button className="back-link-btn" onClick={() => navigate(-1)}>Back to Services</button>
      <section className="details-hero-section">
        <h1>{data.title}</h1>
        <p className="significance-text">{data.significance}</p>
      </section>

      <section className="details-gallery">
        <div className="main-image-container">
          {gallery[activeImg] && <img src={gallery[activeImg]} alt={data.title} className="main-gallery-img" />}
        </div>
        <div className="thumbnail-strip">
          {gallery.map((img, index) => (
            <div
              key={img}
              className={`thumb-box ${activeImg === index ? 'active' : ''}`}
              onClick={() => setActiveImg(index)}
            >
              <img src={img} alt="Thumbnail" />
            </div>
          ))}
        </div>
      </section>

      <div className="details-info-grid">
        <div className="info-card">
          <h3>Why Perform This?</h3>
          <ul className="custom-bullet-list">
            {(data.whyPerform || []).map((reason, i) => <li key={i}>{reason}</li>)}
          </ul>
        </div>

        <div className="info-card">
          <h3>The Ritual Process</h3>
          <div className="vertical-steps">
            {(data.ritualProcess || []).map((step, i) => (
              <div key={i} className="step-row">
                <span className="step-circle">{i + 1}</span>
                <p>{step}</p>
              </div>
            ))}
          </div>
        </div>

        {(data.pricing_tiers || []).length > 0 && (
          <div className="info-card full-span">
            <h3>Actions by Duration</h3>
            <div className="duration-action-grid">
              {(data.pricing_tiers || [])
                .map((tier) => (
                  <div className="duration-action-card" key={tier.id || tier.duration}>
                    <div className="duration-action-header">
                      <span>{tier.duration}</span>
                      <strong>
                        {tier.discountActive && Number(tier.originalPrice || 0) > Number(tier.price || 0) && (
                          <del>${Number(tier.originalPrice).toFixed(2)}</del>
                        )}
                        ${Number(tier.price || 0).toFixed(2)}
                      </strong>
                    </div>
                    {(tier.label || tier.discountActive) && <p>{tier.label}{tier.discountActive ? `${tier.label ? ' · ' : ''}${tier.discountLabel || 'Limited-time discount'}` : ''}</p>}
                    <ul className="custom-bullet-list compact">
                      {tier.actions.map((action, i) => <li key={`${tier.id || tier.duration}-${i}`}>{action}</li>)}
                    </ul>
                  </div>
                ))}
            </div>
          </div>
        )}

        <div className="info-card full-span">
          <h3>Requirements & Setup</h3>
          <table className="ritual-table">
            <thead>
              <tr><th>Category</th><th>Details</th></tr>
            </thead>
            <tbody>
              <tr><td><strong>Essential Samagri</strong></td><td>{(data.itemsRequired || []).join(', ')}</td></tr>
              <tr><td><strong>Preparation</strong></td><td>{data.preparation}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>
  );
};

export default PoojaDetails;
